/* eslint-disable no-console */

const asciiArt = `
                    ......                            ......
             .^7YPB##&&&##BG5J!:                :!J5GB##&&&##BPY7^.
          :?P#BSPBSPBSPBSPBSPBS&BY~          ~YB&BSPBSPBSPBSPBSPBS#P?:
        ~P&BSPBSPBS&##BB#&&BSPBSPBSBJ:    .J#BSPBSPBS&&#BB##&BSPBSPBS&P~
      ~GBSPBSPBGY!^.     .:~?P#BSPBSP&Y:   !GBSPB#P?~:.     .^!YBBSPBSPBG^
     JBSPBSP#J:    :~!!!~^.   .!PBSPBSP&5^   ~PP!.   .^~!!!~:    :J#BSPBSPJ
    5BSPBSPJ.  .!5#&BSPBSP&GJ^   ^5&BSPBSPP~      ^JG&BSPBSP&#5!.  .JBSPBSP5
   ?BSPBS&~   7#BSPBSPBSPBSPBSP~   ^Y&BSPBSPG!  :5BSPBSPBSPBSPBS#7   ~&BSPBSJ
  :&BSPBS!   YBSPBSPBSPBSPBSPBSPG!   :J&BSPBSPG?#BSPBSPBSPBSPBSPBSY   !BSPBS&:
  7BSPBSG   !BSPBSPBSPBSPBSPBSPBSPG!   .?#BSPBSPBSPBSPBSPBSPBSPBSPB!   GBSPBS7
  JBSPBS5   YBSPBSPBSPBSPBSPBSPBSPBSB7.  .7BBSPBSPBSPBSPBSPBSPBSPBSJ   5BSPBSJ
  7BSPBSG   !BSPBSPBSPBSPBSPBSPBSPBSPB#?.   !BBSPBSPBSPBSPBSPBSPBSP!   GBSPBS7
  :&BSPBS!   YBSPBSPBSPBSPBSPBS#?GBSPBSP#J:   !GBSPBSPBSPBSPBSPBSPY   !BSPBS&:
   ?BSPBS&~   7#BSPBSPBSPBSPBS5:  !GBSPBSP&Y:   ~PBSPBSPBSPBSPBS#7   ~&BSPBSJ
    5BSPBSPJ.  .!5#&BSPBSP&GJ^      ~PBSPBSP&5^   ^JG&BSPBSP&#5!.  .JBSPBSP5
     JBSPBSP#J:    :~!!!~^.   .!PP~   ^5&BSPBSPP!.   .^~!!!~:    :J#BSPBSPJ
      ~GBSPBSPBGY!^.     .:~?P#BSPBG!   :Y&BSPBSP#P?~:.     .^!YBBSPBSPBG^
        ~P&BSPBSPBS&##BB#&BSPBSPBSP#J.    :J#BSPBSPBS&&#BB##&BSPBSPBS&P~
          :?P#BSPBSPBSPBSPBSPBS&BY~          ~YB&BSPBSPBSPBSPBSPBS#P?:
             .^7YPB##&&&##BG5J!:                :!J5GB##&&&##BPY7^.
                    ......                            ......
`;

const HIRING_URL = 'https://bndspn.com/join-streamyard';

const logHiringMessage = () => {
	console.log(
		`%c${asciiArt}\n%cWe're hiring! %c${HIRING_URL}`,
		'font-family: monospace; font-size: 7px; line-height: 1.2;',
		'font-size: 16px; font-weight: bold;',
		'font-size: 16px; color: #4a90d9;',
	);
};

export default logHiringMessage;
